import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgAscendingSort = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  return (
    <svg
      viewBox="0 0 6 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 .542c-.04 0-.085.02-.115.05L.55 2.927a.173.173 0 0 0-.05.115c0 .04.02.085.05.115l.25.25c.03.03.076.05.116.05.04 0 .085-.02.115-.05L3 1.44l1.969 1.969c.03.03.075.05.115.05.045 0 .085-.02.115-.05l.25-.25c.031-.03.051-.076.051-.116 0-.04-.02-.085-.05-.115L3.115.592A.173.173 0 0 0 3 .542Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgAscendingSort;
